// extracted by mini-css-extract-plugin
module.exports = {"Button":"button_Button__20cpF"};